import { getProcessList, reportMessageForPage } from '@/api/processList.js'
import lodash from 'lodash'

export const service = {
  getProcessList(data) {
    // const params = {
    //   process_base_status: data.process_base_status
    //   // process_base_status_bit: data.type
    // }
    return new Promise((resolve, reject) => {
      getProcessList(data)
        .then((response) => {
          if (response) {
            const data = lodash.cloneDeep(response.records || [])
            const total = response.total
            for (let i = 0; i < data.length; i++) {
              if (data[i].process_base_drafter) {
                // data[i].process_base_drafter = JSON.parse(data[i].process_base_drafter)
                data[i].drafter_name = data[i].process_base_drafter.user_nick_name
              }
              if (data[i].process_config_type) {
                if (data[i].process_config_type === 'releaseOfFunds') {
                  data[i].process_type = '资金帮扶'
                } else if (data[i].process_config_type === 'activityConfirmation') {
                  data[i].process_type = '活动帮扶'
                } else if (data[i].process_config_type === 'individualCase') {
                  data[i].process_type = '个案帮扶'
                } else if (data[i].process_config_type === 'ghReleaseOfFunds') {
                  data[i].process_type = '资金帮扶-帮侬一把'
                } else if (data[i].process_config_type === 'ghActivityConfirmation') {
                  data[i].process_type = '活动帮扶-帮侬一把'
                } else if (data[i].process_config_type === 'internalDocuments') {
                  data[i].process_type = '内部文件'
                }
              }
              // if (data[i].process_base_table_message) {
              //   data[i].process_base_table_message = JSON.parse(data[i].process_base_table_message)
              //   data[i].projectType = data[i].process_base_table_message.project_type ? data[i].process_base_table_message.project_type[0] : ''
              //   // data[i].project_funding = data[i].process_base_table_message.project_funding// 项目资金
              // }
            }
            resolve({ data, total })
          } else {
            resolve({})
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  reportMessageForPage(data) {
    return new Promise((resolve, reject) => {
      reportMessageForPage(data).then((response) => {
        const data = lodash.cloneDeep(response.records || [])
        const total = response.total
        for (let i = 0; i < data.length; i++) {
          data[i].drafter_name = data[i].report_message_creator
            ? data[i].report_message_creator.user_nick_name
            : ''
        }
        resolve({ data, total })
      })
    })
  }
}
